import {handleValidationChange} from '../CommonValidation';

export const validateBanks = (data, setIsError) => {
    //Required 
    // bank_name: "",

    var isValid = true;

    if(data.bank_name === "" || data.bank_name === undefined) {
        handleValidationChange("bank_name", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("bank_name", false, setIsError);
    }
    
    if(data.account_name === "" || data.account_name === undefined) {
        handleValidationChange("account_name", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("account_name", false, setIsError);
    }

    if(data.account_no === "" || data.account_no === undefined) {
        handleValidationChange("account_no", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("account_no", false, setIsError);
    }

    return isValid
  
}